const guideIndexOff = -1;

export default (initialState = {}) => ({
  namespaced: true,
  state: () => ({
    guideIndex: guideIndexOff,
    isOpen: false,
    panel: 'info',
    ...initialState,
  }),
  actions: {
    selectPanel: ({ commit }: any, panel: string) => (
      commit('SELECT_PANEL', panel)
    ),
    toggleSidebar: ({ commit }: any, value: boolean) => (
      commit('TOGGLE_SIDEBAR', value)
    ),

    // guide methods
    endGuide: ({ commit }: any) => (
      commit('UPDATE_GUIDE_INDEX', guideIndexOff)
    ),
    guideStep: ({ commit }: any, value: number) => (
      commit('UPDATE_GUIDE_INDEX', value)
    ),
    nextGuide: ({ commit, state }: any) => (
      commit('UPDATE_GUIDE_INDEX', state.guideIndex + 1)
    ),
    startGuide: ({ commit }: any) => {
      // turn off and then on again
      commit('UPDATE_GUIDE_INDEX', guideIndexOff);
      // allow next tick to happen and start again
      setTimeout(() => {
        commit('UPDATE_GUIDE_INDEX', 0);
      }, 0);
    },
  },
  mutations: {
    SELECT_PANEL: (state: any, panel: string) => {
      state.panel = panel;
      state.isOpen = true;
    },
    TOGGLE_SIDEBAR: (state: any, value: boolean) => {
      state.isOpen = value;
    },
    UPDATE_GUIDE_INDEX: (state: any, value: number) => {
      state.guideIndex = value;
    },
  },
});
